<template>
    <div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="params.fab ? params.fab : false"
						:icon="params.fab ? false : true"
						:small="params.small ? true : false"
						:fixed="params.fixed ? true : false"
						:bottom="params.bottom ? true : false"
						:right="params.right ? true : false"
						:dark="params.dark ? true : false"
						:color="params.button_color ? params.button_color : ''"
						@click="toggleDialog">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ icon }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ tooltipText }}</span>
    		</v-tooltip>
		</template>

        <v-list-item v-else-if="buttonComponent == 'v-list-item'"
            dense 
            :disabled="disabled"
            @click.stop="toggleDialog(true)"
            ripple>
            <v-list-item-icon>
                <v-icon style="font-size: 18px">{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ tooltipText }}</v-list-item-title>
            </v-list-item-content>    
        </v-list-item>

        <upload-file-dialog
            :open.sync="dialog"
            :model-def="modelDef"
            :params="button.params"
            :button="button"
            :model="model"
            @close="toggleDialog(false)"
            :selectedIds="[model.id]"
            :selected="[{'id': model.id}]"
        ></upload-file-dialog>
    </div>

</template>

<script>
    import UploadFileDialog from '@/components/common/UploadFileDialog'

    export default {
        name: 'upload-file-button',
        components: {
            UploadFileDialog
        },
        props: {
            id: Number,
            button: Object,
            buttonComponent: {type: String, default : 'v-btn'},
            model: Object,
            params: Object,
            modelDef: String,
            disabled: Boolean,
        },
        data() {
            return {
                dialog: false
            }
        },

        computed: {

            icon() {
                if (this.button.params && this.button.params.icon) {
                    return this.button.params.icon
                } else {
                    return 'mdi-cloud-upload-outline'
                }
            },

            tooltipText() {
                if (this.button.params && this.button.params.tooltip) {
                    return this.button.params.tooltip
                } else {
                    return 'Upload CSV'
                }
            },
        },

        methods: {
            toggleDialog(value) {
                this.dialog = value
                if(!value) {
                    this.$eventBusUtility.$emit('showButtonsList', false)
                }
            }
        }
    }
</script>